import { render, staticRenderFns } from "./ExpandedAccessPolicy.vue?vue&type=template&id=6d7ed812&scoped=true&"
import script from "./ExpandedAccessPolicy.vue?vue&type=script&lang=ts&"
export * from "./ExpandedAccessPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedAccessPolicy.vue?vue&type=style&index=0&id=6d7ed812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7ed812",
  null
  
)

export default component.exports